import {OptionTypeWithoutId} from '../../utils/core/_model'

export const getMsisdn = (options: OptionTypeWithoutId[]) => {
  return options.map((opt) => opt.value)
}

export const parsingIntoString = (ids: number[]) => {
  const stringIds = ids.map((id) => id.toString())

  return stringIds
}
